import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './OrganizerInfo.scss';

export type Props = {
    profileLink: string;
    nameTruncated: string;
};

export const OrganizerInfo = ({ profileLink, nameTruncated }: Props) => {
    const linkTitle = gettext("Go to the organizer's profile");

    const organizerNameMarkup = {
        __html: gettext(
            'By <a title="%(linkTitle)s" href="%(profileLink)s" target="_blank" rel="noreferrer">%(nameTruncated)s</a>',
            { profileLink, nameTruncated, linkTitle },
        ).toString(),
    };

    return (
        <div className="organizer-info">
            <div
                className="organizer-info__name"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={organizerNameMarkup}
            />
            <span id="listings-root__follow-organizer_hero"></span>
        </div>
    );
};
